export function formatKm(value: string | number) {
    let parsedValue = value;
    if (typeof parsedValue === 'string') {
        parsedValue = parseInt(parsedValue, 10);
    }
    if (isNaN(parsedValue)) {
        return null;
    }

    if ('Intl' in window) {
        const formatter = new Intl.NumberFormat('nl-NL', {
            style: 'unit',
            unit: 'kilometer',
            unitDisplay: 'short',
            maximumFractionDigits: 0,
        });
        return formatter.format(parsedValue);
    }

    return `${parsedValue.toLocaleString()} km`;
}
